// NewLeadsTable.jsx
import { useState } from "react";
import { formatDate, MappingStatus, MappingStyles } from "../../utils/utils";

export default function NewLeadsTable({
  selectedAll,
  handleSelectApplicant,
  filteredApplicants,
  selectedApplicants,
  handleSelectAll,
  handleViewApplication,
}) {
  return (
    <div className="bg-[#131313] rounded-lg border border-[#333333] w-full overflow-x-auto scrollbar-hide">
      <table className="min-w-full">
        <thead className="border-y border-[#333333]">
          <tr>
            <th className="p-4 text-center border-2 border-[#333333]">
              <input
                type="checkbox"
                className="appearance-none h-5 w-5 border-2 border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                      before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                checked={selectedAll}
                onChange={handleSelectAll}
              />
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">DATE</th>
            <th className="p-4 text-center border-2 border-[#333333]">
              APPLICANT NAME
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              LOAN AMOUNT
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              STATUS
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              MODE OF LEAD GENERATION
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              ASSIGNED TO
            </th>
            <th className="p-4 text-center border-2 border-[#333333]">
              ACTIONS
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredApplicants.length === 0 ? (
            <tr>
              <td colSpan="8" className="p-6 text-center text-gray-400">
                No rows found
              </td>
            </tr>
          ) : (
            filteredApplicants.map((applicant) => (
              <tr key={applicant._id}>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <input
                    type="checkbox"
                    className="appearance-none h-5 w-5 border-2 border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                      before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                    checked={selectedApplicants.includes(applicant._id)}
                    onChange={() => handleSelectApplicant(applicant._id)}
                  />
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  {formatDate(applicant.createdAt)}
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  {applicant?.user?.name || applicant?.username || "N/A"}
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <div>
                    <div>{applicant.principle}</div>
                    <div className="text-sm text-gray-400">
                      {applicant.loanType}
                    </div>
                  </div>
                </td>

                <td className="p-2 md:p-4 text-center border-2 border-[#333333]">
                  <span
                    className={`px-2 md:px-3 py-1 rounded-full text-xs md:text-sm whitespace-nowrap ${MappingStyles(
                      applicant.status
                    )}`}
                  >
                    {MappingStatus(applicant.status)}
                  </span>
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  {applicant.leadGeneration}
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <span>{applicant.assignedTo?.name}</span>
                </td>
                <td className="p-4 text-center border-2 border-[#333333]">
                  <button
                    className="text-[#FFCA20] hover:text-[#FFCA20]"
                    onClick={() => handleViewApplication(applicant._id)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
